<template>
  <v-dialog
    v-model="dialog"
    persistent
    scrollable
    max-width="700px"
  >
    <v-card :loading="loading">
      <v-card-title>
        <span>Quy trình sản xuất</span>
        <v-spacer/>
        <v-menu
          bottom
          left
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              @click="close()"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
        </v-menu>
      </v-card-title>
      <v-card-text>
        <v-container id="qrPrintElem">
          <v-card flat>
            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <strong><li>Tên sản phẩm: {{ item.ten_sp }}</li></strong>
                  <strong><li>Đơn vị sản xuất: {{ item.business ? item.business.ten_co_so : '' }}</li></strong>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <v-card flat>
            <v-card-title class="subheading font-weight-bold">
              Sản xuất, nuôi trồng
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <strong><li>Tên giống:</li></strong>
                  <div v-html="item.ten_giong"></div>
                  <strong><li>Nguồn gốc:</li></strong>
                  <div v-html="item.nguon_goc"></div>
                  <strong><li>Quy trình sản xuất:</li></strong>
                  <div v-html="item.quy_trinh_sx"></div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <v-card flat>
            <v-card-title class="subheading font-weight-bold">
              Thu hoạch
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <strong><li>Ngày thu hoạch, đóng gói:</li></strong>
                  <div v-html="item.ngay_thu_hoach_dg"></div>
                  <strong><li>Sản lượng:</li></strong>
                  <div v-html="item.san_luong"></div>
                  <strong><li>Kho, xưởng:</li></strong>
                  <span v-for="(item, index) in item.product_warehouses" :key="index">
                    {{ item.ten_kho }};
                  </span>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <v-card flat>
            <v-card-title class="subheading font-weight-bold">
              Sơ chế, đóng gói
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <strong><li>Hạn sử dụng:</li></strong>
                  <div v-html="item.han_su_dung"></div>
                  <strong><li>Quy cách:</li></strong>
                  <div v-html="item.quy_cach"></div>
                  <strong><li>Cách bảo quản:</li></strong>
                  <div v-html="item.cach_bao_quan"></div>
                  <strong><li>Đơn vị kiểm định:</li></strong>
                  <div v-html="item.don_vi_kt"></div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          color="pink darken-1"
          text
          @click="close"
        >
          Hủy bỏ
        </v-btn>
        <v-btn
          color="primary darken-1"
          text
          v-print="'#qrPrintElem'"
        >
          <v-icon>
            mdi-printer
          </v-icon>
          In
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  import { mapState, mapActions } from 'vuex';
  export default {
    props: {
      showDialog: {
        type: Boolean,
        default: false
      },
      item: {
        type: Object
      }
    },
    data () {
      return {
        loading: false,
        dialog: false
      }
    },
    computed: {
      ...mapState([ 
        'config'
      ])
    },
    mounted() {
      this.dialog = this.showDialog;
    },
    watch: {
      showDialog() {
        this.dialog = false;
        if (this.showDialog) {
          this.dialog = true;
        }
      }
    },
    methods: {
      ...mapActions([
        'openSnackbar'
      ]),
      close() {
        this.dialog = false;
        this.$emit('cancelled');
      }
    }
  }
</script>